<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('registers.organizers.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group">
                <button type="button"
                        class="btn btn-primary"
                        @click="redirectToList">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('company.cardTitle') }}</div>
                </div>
                <div class="card-body">
                    <company-details :company="organizer.company"></company-details>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('places.otherFields') }}</div>
                </div>

                <div class="card-body">
                    <other-fields-details :otherFields="organizer.otherFields"></other-fields-details>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('contract.cardTitle') }}</div>
                </div>

                <div class="card-body">
                    <contract-details v-for="(contract,index) in organizer.contracts"
                        :key="index"
                        :contract="contract"
                        :title="$t('contract.cardTitle')">
                    </contract-details>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('documents') }}</div>
                </div>
                <div class="card-body">
                    <div v-for="(document,index) in organizer.documents" :key="index" class="mt-2 border border-light-2 p-2">
                        <div class="form-control">
                            <label :for="'document' + _uid" class="font-weight-bold">{{$t('document')}}</label>
                        </div>
                        <div class="mt-2">
                            <file-download :file="document"></file-download>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3" v-if="organizer">
                <AuxiliaryRegisterDetails :entryId="organizer.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import CompanyDetails from './../../../components/company/CompanyDetails';
    import ContractDetails from './../../../components/contract/ContractDetails';
    import OtherFieldsDetails from '../../../components/otherFields/OtherFieldsDetails';
    import FileDownload from '../../../components/common/FileDownload.vue';
    import { OrganizerDetails } from './../../../models/models.js';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'
    import PageTitle from '../../../components/common/PageTitle';


    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        components: {
            "company-details": CompanyDetails,
            'contract-details': ContractDetails,
            'other-fields-details': OtherFieldsDetails,
            FileDownload,
            AuxiliaryRegisterDetails,
            PageTitle
        },
        data() {
            return {
                loading: false,
                organizer: new OrganizerDetails(),
            }
        },
        mounted: function () {
            this.load();
        },
        methods: {
            load() {
                this.loading = true;
                this.$http.get('/api/organizers/getDetails/' + this.id)
                    .then(response => {
                        this.organizer = new OrganizerDetails(response.data);
                        console.log(this.organizer);
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('buttons.load.btnText'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.loading = false; });
            },
            redirectToList() {
                this.$router.push(this.returnUrl || '/registers/organizers');
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
